import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import toastr from "../../../utils/toast";

function EditDesignation({ id, onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  
  const {
      register,
      handleSubmit,
      watch,
      setValue,
      unregister,
      formState: { errors },
    } = useForm();
  const [ref, setref] = useState([]);
  const [subDepartment, setsubDepartment] = useState([]);
  
  const fetchOptions = async() => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/settings/get_designation_details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            },
          }
        );
        if(response.data.designation.length > 0){
          setref(response.data.designation?.[0]);
        }
        
      } catch (error) {
        console.error("API Error:", error);
        setGlobalLoading(false);
      }
    }

  useEffect(() => {
   fetchOptions();
  }, [id]);

  useEffect(()=>{
    setValue("id",ref.id);
    setValue("name",ref?.name);
    setValue("details",ref?.details);
    setValue("sub_department_id",ref?.sub_department_id);
  },[ref, subDepartment]);

  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/settings/get_sub_department_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      //  const data = res.data;
        setsubDepartment(res.data.sub_department || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/settings/edit_designation`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Designation update successfully!");
      onClose();
      setTimeout(() => {
        navigate("/settings/designations");
      }, 1000);

      // setShowModal(false);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 

   return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Edit Designation</h4>
              <button
                onClick={() => onClose()}
                type="button" className="btn-close custom-btn-close"
                data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">Designation Name *</label>
                    <input type="hidden" {...register("id")} />
                    <input type="text" {...register("name", { required: "required" })} className={`form-control ${ errors.firstname && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Details *</label>
                    <input type="text" {...register("details", { required: "required" })} className={`form-control ${ errors.username && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Sub Department *</label>
                    <select {...register("sub_department_id", {required: "Please select Sub Department",})} className={`form-select ${ errors.parent && "is-invalid" }`}>
                      <option value="">Select</option>
                      {subDepartment.map((m) => (
                        <option key={m.id} value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   );  

}    
export default EditDesignation;